import React from "react";
import useDeliveryCertificate from "./useDeliveryCertificate";
import {
  Button,
  IconText,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import AddStatus from "../../../Global/AddStatus";
import Style from "../delivery.module.scss";
import EditPrint from "../EditPrint";
import PassAll from "../../../Global/PassAll";
import RemarksTable from "../../../Global/RemarksTable";
import { Table } from "../../../Global/Table";

const DeliveryCertificate = ({ gliNumber, slipRef, chellanRef }) => {
  const {
    paginationOptions,
    deliveryState,
    disableMultiSelect,
    certificateList,
    isFetching,
    formik,
    passAllModal,
    globalRemarkModal,
    isLoading,
    handleSearch,
    loading,
    loadingChellan,
    handleModalClose,
    handlePrintChellan,
    handlePrintSlip,
    getRow,
    handleConfirm,
    handlePageSize,
    handlePagination,
    handleConfirmModal,
    handlePassAll,
    handlePassAllClick,
    handleEditPrintModal,
    handleCloseModal,
    handleClearClick,
    showUploadModal,
    uploadLoading,
    uploadFile,
    handleUploadModalOpen,
    handleUploadModalClose,
    handleFileChange,
    handleUploadSubmit,
    handleDeliveryDownload,
  } = useDeliveryCertificate({ slipRef, chellanRef });

  return (
    <>
      <div className={`${Style.print_head} pro-flex-column`}>
        <div className="pro-mb-3">
          <h5 className="pro-ttl h5 pro-mb-0">{gliNumber}</h5>
        </div>
        <div className="pro-w-full pro-d-flex gap-2 pro-space-between">
          <SearchFilters
            onSearchInput={handleSearch}
            showActions={false}
            loading={isLoading}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            showClearFilters
            handleClear={handleClearClick}
            searchInputProps={{ placeholder: "Search Certificate Number" }}
          />
        </div>
        <div className={Style.btns}>
          <button
            className={`pro-btn pro-btn-outline pro-items-center`}
            onClick={handleEditPrintModal}
          >
            <span className="material-symbols-outlined">edit</span>
            <span>Edit</span>
          </button>
          <button
            className={`pro-btn pro-btn-outline pro-items-center`}
            onClick={handlePassAllClick}
          >
            <span className="material-symbols-outlined">check_circle</span>
            <span>Pass All</span>
          </button>
          <button
            className={`pro-btn pro-btn-outline pro-items-center ${loading ? "loading" : ""}`}
            onClick={handlePrintSlip}
          >
            <span className="material-symbols-outlined">print</span>
            <span>Print Slip</span>
          </button>
          {/* <button
            className={`pro-btn pro-btn-outline pro-items-center ${loadingChellan ? "loading" : ""}`}
            onClick={handlePrintChellan}
          >
            <span className="material-symbols-outlined">print</span>
            <span>Print Challan</span>
          </button> */}
          <button
            className={`pro-btn pro-btn-outline pro-items-center`}
            onClick={handleUploadModalOpen}
          >
            <span className="material-symbols-outlined">upload</span>
            <span>Upload</span>
          </button>
          <button
            className={`pro-btn pro-btn-outline pro-items-center`}
            onClick={handleDeliveryDownload}
          >
            <span className="material-symbols-outlined">download</span>
            <span>Download</span>
          </button>
        </div>
      </div>
      <Table
        multiSelect={disableMultiSelect ? false : true}
        loading={isFetching}
        data={certificateList?.data?.data || []}
        uniqueID={"id"}
        fields={certificateList?.data?.fields || []}
        showCheckBox={true}
        SortIcon={<FaSort />}
        getRow={getRow}
        perpage={10}
        assignable={true}
        editable={false}
        deletable={false}
        assignText={"Submit"}
        assignIcon={
          <span className="material-symbols-outlined">check_circle</span>
        }
        handleAssign={handleConfirmModal}
        clear={deliveryState?.clear}
        tableWrapClassName={"print_head_table"}
      />
      <ModalLayout
        show={deliveryState?.showAddDeliverySecModal}
        handleClose={handleConfirmModal}
        title={"Choose status of submission?"}
      >
        <div className="pro-m-5">
          <AddStatus
            handleConfirm={handleConfirm}
            handleConfirmModal={handleConfirmModal}
            excludedStatuses={["Marked", "Rejected", "Recheck"]}
          />
        </div>
      </ModalLayout>

      <Pagination
        currentPage={deliveryState?.currentTablePage}
        totalPageCount={Math.ceil(
          certificateList?.data?.total_count / certificateList?.data?.per_page,
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />
      <OffCanvasLayout
        show={deliveryState?.showPrintEditModal}
        handleClose={handleCloseModal}
        title={"Edit Certificate"}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <EditPrint />
      </OffCanvasLayout>
      <ModalLayout
        show={passAllModal}
        title={"Pass All"}
        handleClose={handlePassAllClick}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <PassAll
          formik={formik}
          handleSubmit={handlePassAll}
          handleCancel={handlePassAllClick}
        />
      </ModalLayout>
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{ root: "pro-modal-xxl" }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTable />
        </div>
      </ModalLayout>
      <ModalLayout
        show={showUploadModal}
        handleClose={handleUploadModalClose}
        title={"Upload Document"}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <div className="input-wrap pro-mb-4">
            <label className="pro-font-sm pro-mb-1 pro-fw-medium">
              Upload File
            </label>
            <div className="input-drag">
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                className="pro-input lg"
                onChange={handleFileChange}
              />
              <span className="input-drag-box" style={{ padding: "50px" }}>
                {uploadFile?.name ? (
                  uploadFile.name
                ) : (
                  <IconText title="Drop Excel, PDF, JPG, or PNG files to attach or browse" />
                )}
              </span>
            </div>
          </div>
          <div className="col-12 pro-d-flex pro-justify-end">
            <Button
              className="pro-btn-link lg pro-px-5"
              onClick={handleUploadModalClose}
            >
              Cancel
            </Button>
            <Button
              className={`pro-btn-primary lg pro-ms-3${uploadLoading ? " loading" : ""}`}
              onClick={handleUploadSubmit}
              disabled={uploadLoading || !uploadFile}
            >
              Submit
            </Button>
          </div>
        </div>
      </ModalLayout>
    </>
  );
};

export default DeliveryCertificate;
